import React from 'react'
import CardTable from 'components/Cards/CardTable'

export default function FeedbackTable() {
  return (
    <CardTable />
  )
}
